import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col text-center px-0"
}
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = { class: "node-profile-pic" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "node-data d-flex justify-content-center small text-nowrap overflow-hidden mb-1" }
const _hoisted_8 = { class: "d-flex align-items-center me-1" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "fw-bold mb-0" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "node-detail" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "d-flex flex-column border border-top-0 border-bottom-0 py-1 px-2" }
const _hoisted_15 = { class: "d-flex flex-row justify-content-stretch" }
const _hoisted_16 = { class: "d-flex flex-column col-6 border-end" }
const _hoisted_17 = { class: "d-flex flex-column col-6" }
const _hoisted_18 = { class: "d-flex flex-row align-items-stretch" }
const _hoisted_19 = { class: "d-flex flex-column flex-fill" }
const _hoisted_20 = { title: "Patrocinador" }
const _hoisted_21 = ["data-bs-target"]
const _hoisted_22 = {
  key: 1,
  class: "col text-center"
}
const _hoisted_23 = { class: "d-flex justify-content-center my-3 me-1" }
const _hoisted_24 = {
  key: 3,
  class: "col text-center"
}
const _hoisted_25 = { class: "d-flex justify-content-center my-3 ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_rank_icon = _resolveComponent("rank-icon")!
  const _component_binary_node = _resolveComponent("binary-node", true)!

  return (_ctx.node?.username != '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex flex-column align-items-stretch justify-content-start my-3 px-1", _ctx.NodeColClass])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["position-relative node border-1 rounded text-truncate overflow-hidden flex-column p-2", [
            _ctx.UserAcademyStatusClass,
            _ctx.isVIP ? 'vip-stroke vip-background-color' : 'border',
          ]]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRootUserFunc(_ctx.node.username)))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.profilePic,
                  alt: _ctx.node.nickname,
                  class: _normalizeClass(["img-fluid rounded-circle gtr-avatar-bg", 
                _ctx.isVIP ? 'vip-stroke vip-shadow border-1' : 'border border-1'
              ])
                }, null, 10, _hoisted_4)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass('distributor-status ' + _ctx.UserDistributorStatusClass),
                title: _ctx.UserDistributorRemainingDays.toLocaleString() + ' días'
              }, [
                _createVNode(_component_package_icon, { product: "distributor-license" })
              ], 10, _hoisted_5),
              _createElementVNode("span", {
                class: _normalizeClass('user-status badge rounded-pill ' + _ctx.UserAcademyStatusClass),
                title: _ctx.UserAcademyRemainingDays.toLocaleString() + ' días'
              }, _toDisplayString(_ctx.UserAcademyRemainingDays.toLocaleString()), 11, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_rank_icon, {
                    "icon-class": _ctx.UserRank?.iconClass,
                    "extra-class": "fs-5 fa-fw"
                  }, null, 8, ["icon-class"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.node.nickname), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.node.username), 1)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ms-1" }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(' fab fs-5 fa-fw')
                  })
                ], -1))
              ])
            ], 2),
            (_ctx.node.binarySide && _ctx.UserAcademyRemainingDays > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["position-absolute", 'icon-' + _ctx.node.binarySide])
                }, [
                  _createVNode(_component_package_icon, {
                    product: _ctx.UserPackageVisual,
                    colored: ""
                  }, null, 8, ["product"])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "collapse",
              id: 'n_' + _ctx.nodeId() + '_details'
            }, [
              _createElementVNode("div", _hoisted_14, [
                _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-flex flex-row justify-content-center\" data-v-39af94e3><div class=\"d-flex flex-column fw-bold text-truncate\" data-v-39af94e3> Puntos Pendientes </div></div><div class=\"d-none d-flex flex-row justify-content-around\" data-v-39af94e3><div class=\"d-flex flex-column\" data-v-39af94e3> Izquierdo </div><div class=\"d-flex flex-column\" data-v-39af94e3> Derecho </div></div>", 2)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.node.points.left.pending.toLocaleString()), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.node.points.right.pending.toLocaleString()), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-user-circle fa-fw" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.node.enroller), 1)
                    ])
                  ])
                ])
              ])
            ], 8, _hoisted_13),
            _createElementVNode("div", {
              class: "details-handler collapsed d-flex flex-row justify-content-center border rounded-bottom py-1",
              "data-bs-toggle": "collapse",
              "data-bs-target": '#n_' + _ctx.nodeId() + '_details'
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "d-flex flex-column" }, [
                _createElementVNode("i", { class: "fas fa-angle-double-down" })
              ], -1)
            ]))], 8, _hoisted_21)
          ])
        ], 2),
        (_ctx.level < _ctx.maxLevelsToDisplay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
        'binary-level-' + (_ctx.level * 1 + 1),
        'd-flex row-nowrap mx-0',
        _ctx.node.childLeft == null ? 'no-left-child' : '',
        _ctx.node.childRight == null ? 'no-right-child' : '',
      ])
            }, [
              (_ctx.node.childLeft != null)
                ? (_openBlock(), _createBlock(_component_binary_node, {
                    key: 0,
                    username: _ctx.getChildUsername(_ctx.node.childLeft),
                    level: _ctx.level * 1 + 1,
                    onChangeTreeRoot: _ctx.changeRootUserFunc
                  }, null, 8, ["username", "level", "onChangeTreeRoot"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["node empty-leaf border rounded text-truncate px-1 py-2", _ctx.LeafColClass])
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "far fa-user d-block mb-1" }, null, -1)
                      ]))], 2)
                    ])
                  ])),
              (_ctx.node.childRight != null)
                ? (_openBlock(), _createBlock(_component_binary_node, {
                    key: 2,
                    username: _ctx.getChildUsername(_ctx.node.childRight),
                    level: _ctx.level * 1 + 1,
                    onChangeTreeRoot: _ctx.changeRootUserFunc
                  }, null, 8, ["username", "level", "onChangeTreeRoot"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["node empty-leaf border rounded text-truncate px-1 py-2", _ctx.LeafColClass])
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "far fa-user d-block mb-1" }, null, -1)
                      ]))], 2)
                    ])
                  ]))
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}